import React from "react";
import styled from "styled-components";

import { useGetCurrentUserQuery } from "../../app/accounts/authuser";
import { useGetMileageStatusQuery } from "../../app/mileages/mileage";
import SvgLoadingAnimation from "../loading/index";

const MileageCardStyle = styled.div`
  min-width: 80px;
  aspect-ratio: 1.414/1;
  background-color: #f0f0f0;
  border-radius: 4px;
  background-image: url(${(props) => props.$image});
  background-size: cover;
  background-position: center;
  box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.25);
`;

const MileageBlock = () => {
  const { data: currentUser, isLoading: userLoading, error: userError } = useGetCurrentUserQuery();
  const { data: mileageData, isLoading: mileageLoading, error: mileageError } = useGetMileageStatusQuery();
  const userData = currentUser?.data;
  const mileageStatus = mileageData?.data;

  // ローディング状態の統合
  const isLoading = userLoading || mileageLoading;
  
  // エラー状態の統合
  const error = userError || mileageError;

  if (isLoading) return <SvgLoadingAnimation />;
  if (error) return <div>Error: {error.message || "An unexpected error occurred."}</div>;
  if (!userData) return <div>No user data available</div>;

  return (
    <div className="u-row u-gap8 u-w100" style={{ padding: "8px 12px" }}>
      <MileageCardStyle 
        $image={mileageStatus?.current_stage_image}
      ></MileageCardStyle>
      <div className="u-w100 u-col u-gap2">
        <p className="heading-16">
          {Number(userData?.total_miles).toLocaleString()}
          <span className="bodytext-11">マイル</span>
          <span className="bodytext-11 u-text-light-gray">
            （利用料:{mileageStatus?.current_fee_rate || 0}%）
          </span>
        </p>
        <progress value={70} max={100} style={{ width: "100%" }}></progress>
        <p className="bodytext-11">
          {mileageStatus?.next_stage ? (
            <>
              次のステージまであと
              {Number(mileageStatus.miles_to_next_stage || 0).toLocaleString()}マイル
            </>
          ) : (
            "最高ステージに到達済み"
          )}
        </p>
      </div>
    </div>
  );
};

export default MileageBlock;
